
import AbstractVue from "@/views/AbstractVue";
import { Options } from "vue-class-component";

@Options({
  props: ["title", "icon", "reference"],
})
export default class TestCheck extends AbstractVue {
  title: string;
  icon: string;
  reference: boolean;

  get enabled(): boolean {
    return this.reference;
  }

  set enabled(value: boolean) {
    this.$emit("update", value);
  }
}
